const useAnalytics = () => {
  const { region } = useRegion()
  const { gtag: _gtag, setConsent } = useGtag()

  return {
    gtag(kind: string, name: string) {
      if (region === 'china') {
        setConsent(false)
        return
      }

      _gtag(kind, name)
    }
  }
}

export { useAnalytics }
